import { alpha } from "@mui/material/styles";

/**
 * Presença da equipe (socket + logout no banco), alinhado ao painel Ao vivo do dashboard.
 * online = abas no socket; ausente = fora do socket sem logout registrado; offline = logout >= último acesso.
 */

/**
 * Fundo, borda e acento dos cards de presença (dashboard Ao vivo e console plataforma).
 * @param {import("@mui/material").Theme} theme
 * @param {"online"|"away"|"offline"} kind
 */
export function presenceCardSurface(theme, kind) {
  const isDark = theme.palette.mode === "dark";
  if (kind === "online") {
    return {
      bgcolor: isDark ? alpha(theme.palette.success.main, 0.16) : "#e8f5e9",
      borderColor: isDark ? alpha(theme.palette.success.main, 0.35) : alpha("#2e7d32", 0.22),
      accent: isDark ? theme.palette.success.light : "#43a047",
    };
  }
  if (kind === "away") {
    return {
      bgcolor: isDark ? alpha(theme.palette.warning.main, 0.14) : "#fff8e1",
      borderColor: isDark ? alpha(theme.palette.warning.main, 0.35) : alpha("#f57f17", 0.22),
      accent: isDark ? theme.palette.warning.light : "#f9a825",
    };
  }
  return {
    bgcolor: isDark ? alpha(theme.palette.error.main, 0.12) : "#ffebee",
    borderColor: isDark ? alpha(theme.palette.error.main, 0.32) : alpha("#c62828", 0.2),
    accent: isDark ? theme.palette.error.light : "#e53935",
  };
}

/** Logout efetivo no banco: data_logout >= último acesso (ou sem último acesso válido). */
export function isDbLoggedOut(operator) {
  if (operator?.data_logout == null || operator.data_logout === "") return false;
  const lo = new Date(operator.data_logout).getTime();
  if (Number.isNaN(lo)) return false;
  if (operator.data_ultimo_acesso == null || operator.data_ultimo_acesso === "") return true;
  const acc = new Date(operator.data_ultimo_acesso).getTime();
  if (Number.isNaN(acc)) return true;
  return lo >= acc;
}

/**
 * @param {object} operator - objeto com data_logout, data_ultimo_acesso (snake_case da API)
 * @param {number} socketTabs - contagens de abas no socket para este usuário
 * @returns {"online"|"away"|"offline"}
 */
export function getTeamPresenceKind(operator, socketTabs) {
  const tabs = socketTabs || 0;
  if (tabs > 0) return "online";
  if (isDbLoggedOut(operator)) return "offline";
  return "away";
}

export const TEAM_PRESENCE_SORT_RANK = { online: 0, away: 1, offline: 2 };

/** Cor do indicador de presença (bolinha no avatar). */
export function presenceDotColor(theme, kind) {
  if (kind === "online") return theme.palette.success.main;
  if (kind === "away") return theme.palette.warning.main;
  return theme.palette.error.main;
}
